// @ts-ignore
import React, { ReactNode } from "react";

import { css } from "@compiled/react";

import Header from "../../sections/header";
import AdometryValidationDummyTag from "../adometry/adometry-validation-dummy-tag";

const containerStyle = css({
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    alignSelf: "center"
});

export type MainContainerProps = {
    readonly showHeader?: boolean;
    readonly children?: ReactNode;
};

export const MainContainer = ({
    showHeader = true,
    children
}: MainContainerProps) => {
    return (
        <div css={containerStyle}>
            {showHeader && <Header />}
            {children}
            <AdometryValidationDummyTag />
        </div>
    );
};

export default MainContainer;
